import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageAccountLoginOtpComponent } from './page-account-login-otp.component';

const routes: Routes = [{ path: '', component: PageAccountLoginOtpComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PageAccountLoginOtpRoutingModule { }
